import { themeColors } from "../components/chartTheme";

/**
 * Returns the zone color for a heart rate value.
 * <50 = AMBER, 50-60 = GREEN, 61-90 = AMBER, >90 = RED
 */
export const getHeartRateColor = (value: number): string => {
  if (value < 50) {
    return themeColors.warning;
  }
  if (value >= 50 && value <= 60) {
    return themeColors.success;
  }
  if (value >= 61 && value <= 90) {
    return themeColors.warning;
  }
  return themeColors.error;
};
